import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'a', 'abbr', 'b', 'blockquote', 'br', 'caption', 'code', 'col', 'colgroup',
  'dd', 'div', 'dl', 'dt', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr',
  'i', 'img', 'li', 'ol', 'p', 'pre', 'small', 'span', 'strong', 'sub', 'sup',
  'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul', 'font',
  'center', 'style',
];

const ALLOWED_ATTR = [
  'href', 'src', 'alt', 'title', 'width', 'height', 'style', 'class',
  'align', 'valign', 'bgcolor', 'color', 'border', 'cellpadding',
  'cellspacing', 'colspan', 'rowspan', 'dir', 'face', 'size',
];

/**
 * Sanitize HTML email body content.
 * Strips scripts, event handlers, javascript: URLs, and dangerous data: URIs.
 */
export function sanitizeEmailHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target'],
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'textarea', 'select', 'button'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'],
  });
}

// Hook: force all links to open in new tabs and block remote tracking images
// until a bounded WeBeMail image-proxy route exists.

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }

  // Do not call the inherited EdgeMail image proxy from WeBelieve.
  if (node.tagName === 'IMG') {
    const src = node.getAttribute('src');
    if (src && !src.startsWith('data:') && !src.startsWith('/')) {
      node.removeAttribute('src');
      node.setAttribute('alt', node.getAttribute('alt') || 'Remote image blocked');
    }
  }
});
